import React, { useState } from "react";
import PropTypes from "prop-types";
import Header from "./Header";

const Layout = (props) => {
  const [sidebar, setSidebar] = useState(false);
  const classStorage = localStorage.getItem("classByForm");
  return (
    <div className="wrapper">
      <Header onClickBars={() => setSidebar(!sidebar)} />
      <section
        className={
          classStorage === "" || classStorage === null
            ? "section-container"
            : classStorage
        }
      >
        {props.children}
      </section>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.element,
};

export default Layout;
